import { render, staticRenderFns } from "./chapterView.vue?vue&type=template&id=329bfc80"
import script from "./chapterView.vue?vue&type=script&lang=js"
export * from "./chapterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports